<template>
    <div class="chat-message" :id="'message-'+message.id"
        v-if="isvisible"
        :class="{
            'chat-message__type_system':message.sender == 'system' || message.sender == 'summary_context',
            'chat-message__type_answer':message.sender == 'operator' || message.sender == 'bot',
            'chat-message__type_answer-bot':message.sender == 'bot' 
        }"
    >
        <span v-if="message.sender == 'system' || message.sender == 'summary_context'" v-html="message.message"></span>
        <div v-else-if="message.type == 'audio'">
            <v-audio ref="audio" @togglePlay="togglePlay" :message="message" :id="message.id"/>
        </div>
        <div v-else-if="message.sender == 'help_request'" class="chat-message__warning">
            <svg width="20" height="20" class="chat-message__warning-icon"> 
                <use href="#icon-warning-cercle"></use>
            </svg>
            <div class="chat-message__warning-message">{{message.message}}</div>
        </div>
        <template v-else>
            <div class="chat-message__img" v-if="message.sender == 'message'">
                <img :src="img" alt="">
            </div>
            <div class="chat-message__content" :class="{'chat-message__content-answer':message.sender == 'operator'}">
                <div class="chat-message__head" v-if="message.responsible_user != $store.getters.user.name">
                    {{ message.responsible_user }}
                </div>
                <span ref="htmlMessage" v-html="tMessage"></span>
                <span ref="htmlMessage" >
                    <!-- <div class="chat-message__img-preload">
                        <img :src="noimage" alt="preload">
                    </div> -->
                </span>
                <div class="chat-message__footer">
                    <div class="chat-message__time">
                        <svg v-if="message.is_send && message.is_read " aria-hidden="true" width="12" height="12">
                            <use href="#icon-double-check"></use>
                        </svg>
                        <svg v-else-if="message.is_send || message.is_read " aria-hidden="true" width="12" height="12">
                            <use href="#icon-checked"></use>
                        </svg>
                        {{message.date_created}}
                    </div>
                    <p v-if="message.sender == 'bot'" class="chat-message__bot">
                        ИИ-ассистент
                    </p>
                </div>
            </div>
            
            <div class="chat-message__img-ai" v-if="message.sender == 'bot'">
                <svg aria-hidden="true" width="18" height="18">
                    <use href="#icon-Ai"></use>
                </svg>
            </div>
        </template>
    </div>

</template>

<script>
import api from '@api'
import vAudio from './audio.vue'
import noimage from '@/static/images/chat-noimage.png'
import { eventBus } from '@eventBus'

export default {
    props: {
        message: '',
        img: null
    },
    components: {
        vAudio
    },
    
    data () {
        return {
            isvisible: true,
            tMessage:'',
            noimage
        }
    },
    mounted() {
        eventBus.$on('socketChangeMessage', this.socketChangeMessage);
        if(this.message.fromSocket) this.sendReadStatus()
        
        this.tMessage = this.replaceNWithBr(this.message.message)
        this.$nextTick(() => {
            const $htmlMessage = this.$refs.htmlMessage
            if(!$htmlMessage) {
                return
            }
            const img = $htmlMessage.querySelector('img')
            if(img) {
                img.onload = () =>{
                    this.onImgLoad(this.message)
                }
            }
        })
    },
    methods: {
        togglePlay(id) {
            this.$emit('togglePlay', id)
        },
        furceStopPlay(id) {
            if(id != this.message.id) {
                this.$refs?.audio?.furceStopPlay(id)
            }
        },
        replaceNWithBr(str) {
            return str? str.replace(/\n/g, '<br>') : '';
        },
        sendReadStatus() {
            const message = this.message
            const payload = {
                id: message.id
            }
            return api.chat.messaageUpdate(payload,'','put').then(response=>{
                this.message.is_read = true
            }).catch(error=>{
                this.$toast.error(error.message)
            })
        },
        onImgLoad(message) {
            this.$emit('imgload', {message, is:message.responsible_user != this.$store.getters.user.name})
        },
        socketChangeMessage(messageData) {
            if(messageData.message_id != this.message.id) return
            console.warn({
                tMessage: this.tMessage,
                message: messageData.message
            })
            this.isvisible = false
            this.tMessage = this.replaceNWithBr(messageData.message)
            this.$nextTick(() => {
                this.isvisible = true
            })
            // if(this.value.id != messageData.chat_id) return
            // this.messages.find(item => item.id == messageData.message_id).message = messageData.message
        },
    }
}
</script> 
 